export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboard.vue?vue&type=template&id=dde90f2e"


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard.vue?vue&type=template&id=dde90f2e
// module id = iolc
// module chunks = 0